module.exports = __webpack_public_path__ + "factorContributionsToExposureTrend.c51eb69d3b7452b892d98cd647da3a7d.png";